export default function PageLoader() {
  return (
    <div className="min-h-screen bg-[#050505] flex flex-col items-center justify-center" data-testid="page-loader">
      <img src="/xmd-logo.png" alt="XMD Productions" className="w-56 max-w-[70vw] animate-pulse" />
      <div className="mt-8 h-[2px] w-32 overflow-hidden bg-white/10 rounded-full">
        <div className="h-full w-1/2 bg-[#D4AF37] animate-[loader_1.1s_ease-in-out_infinite]" />
      </div>
      <style>{`@keyframes loader{0%{transform:translateX(-100%)}100%{transform:translateX(300%)}}`}</style>
    </div>
  );
}
